// src/data/menuData.ts
import slugify from '../utils/slugify';
import { IconName } from '../utils/iconMap';
import { Category } from '../data/types';

export interface SubMenuItem {
  label: string;
  link: string;
  description?: string;
  icon?: IconName; // ✅ make optional
}

export interface MenuItem {
  label: string;
  link?: string; // for static items like About/Contact
  submenu?: SubMenuItem[]; // for dropdowns like Category
}

export const buildMenuData = (toolCategories: Category[]): MenuItem[] => [
  // {
  //   label: 'Product',
  //   submenu: [
  //     {
  //       label: 'New AIs',
  //       link: '/new',
  //       description: 'The Latest AIs, every day',
  //       icon: 'Sparkles',
  //     },
  //     {
  //       label: 'Most Used',
  //       link: '/popular',
  //       description: 'Most popular tools this week',
  //       icon: 'BarChart',
  //     },
  //   ],
  // },
  {
    label: 'Home',
    link: '/'
  },
  {
    label: 'Category',
    submenu: toolCategories.map((cat) => ({
      label: cat.title,
      link: `/category/${slugify(cat.title)}`,
      description: `Explore tools in ${cat.title}`,
      icon: 'Folder',
    })),
  },
  {
    label: 'About Us',
    link: '/about'
  },
  {
    label: 'Submit AI Tool',
    link: '/submit-tool'
  },
  {
    label: 'Contact Us',
    link: '/contact'
  },
  {
    label: 'Blog',
    link: '/blog'
  }

];
